<div class="page-header-bar">
  <div class="content85percent">
    <div class="float-start">
      <h1>Clear Sign Portal End User License Agreement</h1>
    </div>
  </div>
</div>
<div class="nex-eula">
  <div class="row margin-top-thirty-px" [innerHTML]="eulaFileContent"></div>
</div>
@if (hasContent && !hasAcceptedEula) {
  <div class="row margin-top-thirty-px">
    <div align="center" style="width: 100%;">
      <button type="button" class="btn-primary" (click)="onAccept()" style="margin-right: 40px;">I ACCEPT</button>
      <button type="button" class="btn-secondary" (click)="onDecline()">I DECLINE</button>
    </div>
  </div>
}
